// Browser-only boot gate for the WASM strategy kernel. Vite resolves
// `@kernel/abg_strategy_wasm` to the web target (default-export `init`,
// async). The .wasm payload comes in via `?url` so Vite hashes it like
// any other asset. Call `initKernel()` once before any consumer of
// `engine.computeLayer` runs — wired in `entrypoints/application.tsx`.
//
// Vitest never imports this file (the nodejs target is synchronous).

import init from "@kernel/abg_strategy_wasm";
// The `?url` query is a Vite asset import — emits the wasm file with a
// hashed filename and yields the resolved URL at runtime.
import wasmUrl from "@kernel/abg_strategy_wasm_bg.wasm?url";

let bootPromise: Promise<void> | null = null;

export function initKernel(): Promise<void> {
  if (!bootPromise) {
    bootPromise = init({ module_or_path: wasmUrl }).then(() => undefined);
  }
  return bootPromise;
}
